;(function () {
  function initStickyBar() {
    var container = document.querySelector('.pdp-bundle-container')
    if (!container) return

    var srcCompare = container.querySelector('.pdp-subtotal-compare')
    var srcCurrent = container.querySelector('.pdp-subtotal-current')
    var srcBtn = container.querySelector('.pdp-cart-btn')
    var srcBtnText = srcBtn ? srcBtn.querySelector('.pdp-cart-btn-text') : null

    var stickyBar = document.querySelector('.pdp-sticky-bar')
    if (!stickyBar) return

    var stickyCompare = stickyBar.querySelector('.pdp-sticky-bar__compare')
    var stickyCurrent = stickyBar.querySelector('.pdp-sticky-bar__current')
    var stickyBtn = stickyBar.querySelector('.pdp-sticky-bar__btn')
    var stickyBtnText = stickyBar.querySelector('.pdp-sticky-bar__btn-text')

    function sync() {
      if (srcCompare) {
        stickyCompare.textContent = srcCompare.textContent
        stickyCompare.style.display = srcCompare.style.display
      }
      if (srcCurrent) {
        stickyCurrent.textContent = srcCurrent.textContent
      }
      if (srcBtn) {
        stickyBtn.disabled = srcBtn.disabled
        stickyBtn.style.backgroundColor = srcBtn.style.backgroundColor
      }
      if (srcBtnText) {
        stickyBtnText.textContent = srcBtnText.textContent
      }
    }

    sync()

    var observer = new MutationObserver(sync)
    if (srcCompare) observer.observe(srcCompare, { attributes: true, childList: true, subtree: true, characterData: true })
    if (srcCurrent) observer.observe(srcCurrent, { childList: true, subtree: true, characterData: true })
    if (srcBtn) observer.observe(srcBtn, { attributes: true })
    if (srcBtnText) observer.observe(srcBtnText, { childList: true, subtree: true, characterData: true })

    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault()
      if (srcBtn && !srcBtn.disabled) srcBtn.click()
    })

    var footer = document.querySelector('footer.custom-footer')
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('pdp-sticky-bar--hidden', entries[0].isIntersecting)
      }, { threshold: 0 })
      footerObserver.observe(footer)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar)
  } else {
    initStickyBar()
  }
})()
